module.exports = "https://qp-assets.quero.com/assets/images/landing/combined-shape.svg?f19acb4e07c938dcea96426557a027cb";